// import { IS_SIDEBAR_OPENED, LocalStorageService  } from '../core/local-storage.service.js';
require('./sidebar-toggle.component.scss');

class SidebarToggleController {
  constructor(
    $scope,
    $rootScope,
    PermissionService,
    RouterService,
    CurrentFilterService,
  ) {
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.CurrentFilterService = CurrentFilterService;
  }

  isPaneClose() {
    return this.router.paneClose;
  }

  switchPanel() {
    this.router.setPane(this.isPaneClose());
  }

  get panel() {
    return this.CurrentFilterService.panel;
  }
}

export const SidebarToggleComponent = {
  template: require('./sidebar-toggle.component.html'),
  controller: SidebarToggleController,
};



// WEBPACK FOOTER //
// ./src/layout/sidebar-toggle.component.js